module.exports = __webpack_public_path__ + "img/1538279748.f462e882.jpg";